var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoutGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_238",
    "data-name": "Group 238",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_237",
    "data-name": "Group 237"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1430",
    "data-name": "Path 1430",
    d: "M136.471,135.093l.01-.01a.374.374,0,0,0,.039-.054s0-.01.01-.015.024-.039.034-.059a.017.017,0,0,1,0-.01c.01-.02.019-.039.029-.064,0,0,0,0,0-.01s.015-.044.024-.069c0,0,0-.01,0-.01a.348.348,0,0,0,.014-.069.045.045,0,0,1,0-.025c0-.02,0-.039.01-.059a.722.722,0,0,0,0-.167.249.249,0,0,0-.01-.059.045.045,0,0,0,0-.024c0-.024-.01-.044-.014-.069,0,0,0-.01,0-.01a.387.387,0,0,0-.024-.069s0,0,0-.01-.019-.044-.029-.064a.017.017,0,0,0,0-.01.365.365,0,0,0-.034-.059s0-.01-.01-.015a.509.509,0,0,0-.039-.054l-.01-.01a.691.691,0,0,0-.058-.064l-4.785-4.84a.825.825,0,0,0-1.176,0,.85.85,0,0,0,0,1.19l3.367,3.41H120.432a.84.84,0,0,0,0,1.68h13.393l-3.343,3.385a.85.85,0,0,0,0,1.19.822.822,0,0,0,1.171,0l4.756-4.816C136.433,135.132,136.452,135.113,136.471,135.093Z",
    transform: "translate(-114.665 -122.562)",
    fill: "#979797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1431",
    "data-name": "Path 1431",
    d: "M22.1,1.68H28.3A.84.84,0,0,0,28.3,0H22.1a4.54,4.54,0,0,0-4.5,4.561V19.439A4.54,4.54,0,0,0,22.1,24H28.2a.84.84,0,0,0,0-1.68H22.1a2.868,2.868,0,0,1-2.845-2.881V4.561A2.868,2.868,0,0,1,22.1,1.68Z",
    transform: "translate(-17.6 0)",
    fill: "#979797"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutGray);
export default __webpack_public_path__ + "static/media/logoutGray.4bf87e1cc6d0c40cbaeef93a1618cedf.svg";
export { ForwardRef as ReactComponent };